module.exports = __webpack_public_path__ + "6d5ddb796c0ad956410c5c39cd751748.svg";